import { LabelsState, SearchActionResponse } from 'types'

export const initialState: LabelsState = {}

export const reducer = (state: LabelsState = initialState, action: SearchActionResponse): LabelsState => {
  switch (action.type) {
    case 'FETCH_LABELS_DONE': {
      const {
        data: {
          queryString,
          response: { result, next, count },
        },
      } = action
      const query = String(queryString || 'default')
      const oldIds = state[query]?.ids
      return {
        ...state,
        [query]: {
          count,
          lastPageLoaded: next - 1,
          ids: [...(oldIds || []), ...result],
        },
      }
    }
    default:
      return state
  }
}

export default reducer
